/**
 * UI 静态图 URL 表（不含 manifests）。
 * manifests 单独解析，避免 ~1000+ 设备图进入模块图、堵死开发态请求队列。
 */
export const uiImageUrls = import.meta.glob<string>(
  [
    '../assets/images/home/**/*',
    '../assets/images/header/**/*',
    '../assets/images/devices/**/*',
    '../assets/images/loading/**/*',
    '../assets/images/recording/**/*',
  ],
  {
    eager: true,
    query: '?url',
    import: 'default',
  },
)
